import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SettingsComponent } from './settings/settings.component';
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ApiService } from './providers/api.service';
import { NavService } from './providers/nav.service';
import { HttpClientService } from './providers/http-client.service';
import { AuthGuard } from './providers/auth.guard';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BoardComponent } from './board/board.component';
import { Last5Component } from './last5/last5.component';
import { TrendsComponent } from './trends/trends.component';
import { FiltersComponent } from './commonComponents/filters/filters.component';
import { ManagerComponent } from './manager/manager.component';
import { NouisliderModule } from 'ng2-nouislider';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { FacebookLoginProvider, AuthService } from 'angular-6-social-login';
import { SocialLoginModule, AuthServiceConfig } from 'angular-6-social-login';
import { CommonService } from './providers/common.service';
import { SocialmediabuttonsComponent } from './commonComponents/socialmediabuttons/socialmediabuttons.component';
import { SidebarfiltersComponent } from './commonComponents/sidebarfilters/sidebarfilters.component';
import { GamestylesectionComponent } from './commonComponents/gamestylesection/gamestylesection.component';
import { AfService } from './providers/af.service';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from 'src/environments/environment';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TooltipModule } from 'ng2-tooltip-directive';
import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';
import { HomeComponent } from './home/home.component';

const config = new AuthServiceConfig([
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    // provider: new FacebookLoginProvider('325973485413885')
    provider: new FacebookLoginProvider('395603625173797')
  },
]);

export function provideConfig() {
  return config;
}

export const firebaseConfig = {
  apiKey: 'AIzaSyC29BQs5JI6S2wQQ4ZvENIUhGZPwmR2d5U',
  authDomain: 'chalkfaders-bab67.firebaseapp.com',
  databaseURL: 'https://chalkfaders-bab67.firebaseio.com',
  storageBucket: 'chalkfaders-bab67.appspot.com',
  messagingSenderId: '236633504297'
};


@NgModule({
  declarations: [
    AppComponent,
    SettingsComponent,
    SigninComponent,
    SignupComponent,
    HeaderComponent,
    FooterComponent,
    DashboardComponent,
    BoardComponent,
    Last5Component,
    TrendsComponent,
    FiltersComponent,
    SocialmediabuttonsComponent,
    ManagerComponent,
    SidebarfiltersComponent,
    GamestylesectionComponent,
    HomeComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ToastrModule.forRoot(),
    Ng2SearchPipeModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    NouisliderModule,
    SocialLoginModule,
    NgxSpinnerModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    CommonModule,
    NgMultiSelectDropDownModule,
    TooltipModule,
    GuidedTourModule.forRoot()
  ],
  providers: [
    ApiService,
    NavService,
    HttpClientService,
    AuthGuard,
    DeviceDetectorService,
    CommonService,
    AfService,
    NgxSpinnerService,
    SocialmediabuttonsComponent,
    GuidedTourService,
    AuthService,
    { provide: AuthServiceConfig, useFactory: provideConfig },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
